"use strict";

const MessageDetailsCtrl = ['$stateParams', 'CRUDService',
function($stateParams, CRUDService){
    this.$onInit = function () {
      this.message = $stateParams.message || this.message;

      if (this.message && this.message.unread) {
        // mark message as read
        this.message.unread = false;

        var msg = angular.copy(this.message);
        delete msg.sender;
        CRUDService.save(msg);
      }
    };
  }];

module.exports = {
  template: `
  <div ng-if="$ctrl.message">
    <dl class="dl-horizontal compact">
      <dt>Absender:</dt>
      <dd>{{$ctrl.message.sender.username}}</dd>

      <dt>Datum:</dt>
      <dd>{{$ctrl.message.createdAt|date:"dd.MM.yyyy HH:mm"}}</dd>

      <dt>Betreff:</dt>
      <dd>{{$ctrl.message.subject}}</dd>
    </dl>
    <samp style="font-size: 1.3em;" ng-bind-html="$ctrl.message.content">
    </samp>
  </div>`,
  binding: {
    'message': '='
  },
  controller: MessageDetailsCtrl
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/app/components/message-details/message-details.component.js